module.exports = __webpack_public_path__ + "img/emphasis-back.e2b800bf.png";